import React from "react";
import Table from "../../Common/Table";
import { getPath, getReadableDateTime } from "../../../utils";
import { getDashboardUrl } from "../../../views/Home";

const DriverStoreMappingChangeLogList = ({ changes, tableFields }) => {
  const getFieldValue = (change, key) => {
    switch (key) {
      case "timestamp":
        return getReadableDateTime(change[key]);
      case "updated_by":
        if (change[key] != "System") {
          const url =
            getDashboardUrl() + `/admin/users/${change[key]}`;
          return (
            <a href={url} target={"_blank"}>
              {change[key]}
            </a>
          );
        } else {
          return change[key];
        }

      default:
        return change[key] !== undefined ? change[key] + "" : "false";
    }
  };

  return (
    getPath(changes, "length", undefined) > 0 && (
      <React.Fragment>
        <h3 className="ml-10">Change Logs</h3>
        <Table
          dataTestid="changelogList"
          list={changes}
          getFieldValue={getFieldValue}
          fields={tableFields}
        />
      </React.Fragment>
    )
  );
};

export default DriverStoreMappingChangeLogList;
